"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const JobView_styled_1 = require("./JobView.styled");
const localization_1 = require("../../localization");
const Search_1 = require("../../presenters/Search/Search");
const useStore_1 = require("../../contexts/useStore/useStore");
const Title_1 = require("../../components/Title/Title");
const PanelPeople_1 = require("../../presenters/PanelPeople/PanelPeople");
const JobView = ({ slug }) => {
    const { open } = (0, useStore_1.useStore)();
    const jobAlias = (0, react_1.useMemo)(() => slug, [slug]);
    const peopleWithJob = (0, react_1.useMemo)(() => open('people').sort(open('people').where((person) => person.attributes['job_alias'] === slug)), [slug, open]);
    return ((0, jsx_runtime_1.jsxs)(JobView_styled_1.JobViewStyled, { children: [(0, jsx_runtime_1.jsx)(Search_1.Search, { className: "search" }), (0, jsx_runtime_1.jsx)(Title_1.Title, { text: jobAlias }), (0, jsx_runtime_1.jsx)("h2", { children: localization_1.localization.job.people }), (0, jsx_runtime_1.jsx)(PanelPeople_1.PanelPeople, { people: peopleWithJob })] }));
};
exports.JobView = JobView;
//# sourceMappingURL=JobView.js.map